module.exports = __webpack_public_path__ + "static/assets/e804f82b4f2eae064277d652ead8c2df.png";